var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{staticClass:"line",attrs:{"fill":"currentColor","d":"M16 11.05l-8.49 8.49 1.42 1.41L16 13.88l7.07 7.07 1.41-1.41L16 11.05z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }